export type ImportIssueColor = "warning" | "error";

export const IMPORT_ISSUE_PALETTE: Record<
  ImportIssueColor,
  {
    color: string;
    border: string;
    accent: string;
    background: string;
    backgroundActive: string;
    iconColor: string;
    removeButtonColor: string;
  }
> = {
  warning: {
    color: "#ed6c02",
    border: "1px solid #ffcc80",
    accent: "#ffcc80",
    background: "#fff3e0",
    backgroundActive: "#ffe0b2",
    iconColor: "#ed6c02",
    removeButtonColor: "#ed6c02",
  },
  error: {
    color: "#d32f2f",
    border: "1px solid #ef9a9a",
    accent: "#ef9a9a",
    background: "#ffebee",
    backgroundActive: "#ffcdd2",
    iconColor: "#d32f2f",
    removeButtonColor: "#d32f2f",
  },
};

export const getFileIssueColor = (
  name: string,
  bigSet: Set<string>,
  duplicateSet: Set<string>,
  diffDimSet: Set<string>,
): ImportIssueColor | null => {
  if (bigSet.has(name) || diffDimSet.has(name)) {
    return "error";
  }
  if (duplicateSet.has(name)) {
    return "warning";
  }
  return null;
};
